import React, { useState, useEffect } from "react";
import { RotateCcw } from "lucide-react";

/**
 * KeviaContinuityBanner — shown briefly when Kevia restores a previous session.
 *
 * Design constraints (FASE 19.7):
 *  - Non-modal, non-blocking
 *  - Fades in softly using .animate-fade
 *  - Auto-hides after 5 seconds
 *  - No close button (too noisy) — just disappears quietly
 *
 * @param {{ age?: number }} props
 *   age — milliseconds since the snapshot was saved (for the label)
 */
export function KeviaContinuityBanner({ age }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 5_000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const ageLabel = age != null
    ? age < 120_000
      ? null                                         // less than 2 min — skip label
      : age < 3_600_000
        ? `de hace ${Math.round(age / 60_000)} min`  // minutes
        : null                                         // too old — skip label
    : null;

  return (
    <div
      className="
        animate-fade flex items-center gap-2
        px-3.5 py-2 rounded-[14px]
        bg-slate-50/90 dark:bg-slate-800/50
        border border-slate-200/50 dark:border-slate-700/40
        text-slate-400 dark:text-slate-500
        shadow-[0_2px_8px_rgba(0,0,0,0.02)]
      "
      role="status"
      aria-live="polite"
    >
      <RotateCcw size={10} className="opacity-40 shrink-0" />
      <span className="text-[11px] font-medium">
        {ageLabel
          ? `Continuando sesión pastoral ${ageLabel}…`
          : "Continuando seguimiento pastoral reciente…"}
      </span>
    </div>
  );
}
